import { HubConnectionState } from "@microsoft/signalr";

export type SignalRStatus = {
    tone: "success" | "warning" | "secondary";
    text: string;
};

export const getSignalRStatus = (connectionState: HubConnectionState): SignalRStatus => {
    switch (connectionState) {
        case HubConnectionState.Connected:
            return {
                tone: "success",
                text: "SignalR connected"
            };
        case HubConnectionState.Connecting:
        case HubConnectionState.Reconnecting:
            return {
                tone: "warning",
                text: "SignalR connecting"
            };
        default:
            return {
                tone: "secondary",
                text: "SignalR disconnected"
            };
    }
};
